namespace Vit {
    export class VitEntityDialog<TItem, TOptions> extends Serenity.EntityDialog<TItem, TOptions> {
        static QueryData: { [id: string]: string; } = null;

        constructor(opt?: TOptions) {
            super(opt);
        }

        protected loadEntity(entity: TItem): void {
            if (VitEntityDialog.QueryData) {
                var form: { [id: string]: Serenity.IReadOnly; } = (<any>this).form;

                for (let item in VitEntityDialog.QueryData) {
                    if (form[item]) {
                        if (form[item].set_readOnly) {
                            form[item].set_readOnly(true);
                        }
                        else {
                            Serenity.EditorUtils.setReadOnly(<Serenity.Widget<any>>(<any>form[item]), true);
                        }
                        entity[item] = VitEntityDialog.QueryData[item];
                    }
                }
            }

            this.createCloneEntity(entity);

            super.loadEntity(entity);
        }

        cloneEntity: any;
        protected createCloneEntity(entity: TItem) {
            this.cloneEntity = { ...entity };
        }
        ignoreChanges = false;
        protected hasChanges(): boolean {
            if (this.ignoreChanges)
                return false;
            var entity = {};
            var editors = this.propertyGrid.get_editors();
            var items = this.propertyGrid.get_items();
            for (var i = 0; i < editors.length; i++) {
                var item = items[i];

                if (item.oneWay !== true) {
                    var editor: any = editors[i];
                    if (editor.getGrid) {
                        if (editor.hasChanges())
                            return true;
                    }
                    else {
                        if (editor.hasValueChanged && editor.hasValueChanged(this.cloneEntity[item.name]))
                            return true;
                    }
                }
            }

            return false;
        }

        //protected initDialog() {
        //    super.initDialog();

        //    var self = this;

        //    this.element.dialog({
        //        beforeClose: function () {
        //            if (self.hasChanges() && !self.isSaved) {
        //                Q.confirm(Q.text("Controls.EntityDialog.CloseBeforeSaveConfirmation"), () => {
        //                    self.ignoreChanges = true;
        //                    self.dialogClose();
        //                });
        //                return false;
        //            }
        //        }
        //    });
        //}

        //protected dialogClose() {
        //    var self = this;
        //    if (this.hasChanges() && !this.isSaved) {
        //        Q.confirm(Q.text("Controls.EntityDialog.CloseBeforeSaveConfirmation"), () => {
        //            self.ignoreChanges = true;
        //            self.dialogClose();
        //        });
        //    }
        //    super.dialogClose();
        //}


        protected changeOwnership() {
            var ownerId = this.getRowOwner() || "";
            //if (ownerId != undefined) {
            this.dialogClose();
            var dialog: Vit.Administration.ChangeOwnershipEditDialog = Serenity.Widget.create({
                type: Vit.Administration.ChangeOwnershipEditDialog,
                options: {},
                init: d => {
                    //this.initEntityDialog(itemType, d);
                    d.load(<Vit.Administration.ChangeOwnershipRow>{
                        Id: this.get_entityId(),
                        UserId: ownerId
                    },
                        () => {
                            d.dialogOpen(false);
                        }, () => {
                            alert("Error!");
                        });
                }
            });
            dialog.setService(this.getService());
            //}
            //else {
            //    Q.notifyError("Owner is not defined!");
            //}
        }

    }
}